module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "m-votes-news"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.votesList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "survey_block"
    }, [_c('div', {
      staticClass: "surveyItem_wrap"
    }, [_c('h4', {
      staticClass: "survey_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "items items_result"
    }, _vm._l((item.options), function(key, value) {
      return _c('li', {
        key: key.id
      }, [_c('h5', [_vm._v(_vm._s(value + 1) + "." + _vm._s(key.title))]), _vm._v(" "), (_vm.isShowResult) ? _c('div', {
        staticClass: "proportion"
      }, [_c('span', {
        staticClass: "bar",
        style: ({
          width: (key.preo_val) + '%'
        })
      }), _vm._v(" "), _c('span', {
        staticClass: "preo_val"
      }, [_vm._v(_vm._s(key.preo_val) + "%")])]) : _vm._e()])
    }), 0)])])
  })], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "m-bt"
  }, [_c('span', {
    staticClass: "u-tt"
  }, [_vm._v("用户调查")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39166114!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news-votes.vue
// module id = 844
// module chunks = 2